/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const shouldRenderBenefitModal = ({
	isDismissed,
	bannerDismissedAt,
}: {
	isDismissed?: boolean;
	bannerDismissedAt?: number | null;
}): boolean => {
	if (!bannerDismissedAt || isDismissed) {
		return false;
	}

	return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};
